import { render, staticRenderFns } from "./LeccionF5.vue?vue&type=template&id=1b068198&"
import script from "./LeccionF5.vue?vue&type=script&lang=js&"
export * from "./LeccionF5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports